import axios from '@/plugins/axios'

export function getTopIndex(params = {}) {
  return axios.get('index/top', {
    params,
  })
}

export function getTodoEvent(params = {}) {
  return axios.get('index/todoEvent', {
    params,
  })
}

export function getProfitChart(params = {}) {
  return axios.get('index/profitChart', {
    params,
  })
}

export function getNewUsersChart(params = {}) {
  return axios.get('index/newUsersChart', {
    params,
  })
}

export function getNewOrderChart(params = {}) {
  return axios.get('index/newOrderChart', {
    params,
  })
}
export function getNewDayRentOrderChart(params = {}) {
  return axios.get('index/newDayRentOrderChart', {
    params,
  })
}

export function getRiddingRanking(params = {}) {
  return axios.get('index/riddingRanking', {
    params,
  })
}
export function getRiddingRankingByDayRentOrder(params = {}) {
  return axios.get('index/riddingRankingByDayRentOrder', {
    params,
  })
}

export function getBikeProfitRanking(params = {}) {
  return axios.get('index/bikeProfitRanking', {
    params,
  })
}

export function getHeatMapData(params = {}) {
  return axios.get('index/heatMap', {
    params,
  })
}

export function getUserPhoneChart(params = {}) {
  return axios.get('index/userPhoneChart', {
    params,
  })
}
